<template>
  <li
    v-if="route.params.role_id"
    class="px-4 bg-white rounded-lg py-4 list-none border-[1px] border-gray-300 text-sm flex gap-4"
  >
    <div class="bg-gray-200 animate-pulse h-12 w-12"></div>
    <div class="flex-grow">
      <div class="w-full flex gap-2 items-center flex-wrap">
        <div class="inline-block h-2 w-2 rounded-full bg-gray-200 animate-pulse"></div>
        <div class="inline-block h-6 flex-grow bg-gray-200 animate-pulse rounded"></div>
        <div class="inline-block h-6 min-w-full flex-grow bg-gray-200 animate-pulse rounded"></div>
      </div>
      <div class="mt-2 h-4 w-full bg-gray-200 animate-pulse rounded"></div>
    </div>
  </li>

  <li
    v-else
    class="px-4 bg-white rounded-lg py-4 list-none flex border-[1px] border-gray-300 text-sm pb-12"
  >
    <div class="h-2 w-2 rounded-full mt-[0.7rem] bg-gray-200 animate-pulse"></div>
    <article class="inline-flex flex-wrap h-auto mx-4 w-full">
      <!-- Title and company -->
      <div class="text-md w-full flex flex-wrap items-center">
        <div class="h-6 w-96 bg-gray-200 animate-pulse rounded"></div>
      </div>

      <!-- Location -->
      <div class="flex flex-wrap gap-2 w-full mt-1">
        <div class="h-5 w-24 bg-gray-200 rounded-full animate-pulse"></div>
        <div class="h-5 w-32 bg-gray-200 rounded-full animate-pulse"></div>
      </div>

      <hr class="w-full border-gray-300 mt-4" />

      <div class="flex items-center flex-wrap w-full mt-2 gap-1">
        <!-- Seniority level -->
        <div class="w-full max-w-[330px] flex flex-wrap gap-1">
          <div class="h-5 w-28 bg-gray-200 rounded animate-pulse"></div>
          <div class="h-5 w-20 bg-gray-200 rounded animate-pulse"></div>
        </div>

        <!-- Applications -->
        <div class="flex gap-2 flex-wrap">
          <div class="h-5 w-24 bg-gray-200 rounded-full animate-pulse"></div>
          <div class="h-5 w-24 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
      </div>

      <!-- Created at -->
      <div class="w-32 h-4 bg-gray-200 rounded animate-pulse mt-2"></div>
    </article>
  </li>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
const route = useRoute()
</script>
